import React , {useEffect , useState} from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Button,
} from "@mui/material";
import * as XLSX from "xlsx";
import { API_BASE_URL2 ,API_BASE_URL} from "../../config/config.js";
import "../Components/Css/CustomerVisit.css";
import "../../CustomerCoverage/css/CustomerCoverageTable.css";
import { useSalesContext } from "../../Pages/SalesContext";
import { useMediaQuery } from '@mui/material';
import {
  Modal,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
interface MonthlyEntry {
  visitdates: any[];
  visits: number;
  dms: number;
  frequency?: number;
}

interface MonthlyData {
  [month: string]: MonthlyEntry;
}

interface HcpData {
  user_role: string;
  user_full_name: string;
  user_name: string;
  total_frequency: ReactNode;
  year: any;
  hcp_details: string;
  dm: string;
  average_monthly_dms: number;
  monthly_visitsAndDMs: MonthlyData;
  total_visit: number;
  total_dm: number;
  frequency : string;
}

interface ApiResponse {
  hcp_table_data: HcpData[];
  GrandTotal?: number;
}
const monthNameMap = {
  apr: "Apr", may: "May", jun: "Jun", jul: "Jul",
  aug: "Aug", sep: "Sep", oct: "Oct", nov: "Nov",
  dec: "Dec", jan: "Jan", feb: "Feb", mar: "Mar"
};

const generateFullFinancialYearMonthsFromYears = (years: string[]): string[] => {
  if (!years || years.length !== 2) return [];

  const startYear = Number(years[0]); // 2025
  const endYear = Number(years[1]);   // 2026

  const months = [
    "apr", "may", "jun", "jul", "aug", "sep",
    "oct", "nov", "dec", "jan", "feb", "mar"
  ];

  return months.map((m) => {
    const year =
      ["jan", "feb", "mar"].includes(m) ? endYear : startYear;

    return `${m}${year % 100}`; // apr25, jan26
  });
};



const CustomerVisitTracker: React.FC =React.memo( () => {
  const [hcpData, setHcpData] = useState<HcpData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
   const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("visit");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { kpiData  } = useSalesContext();
  console.log("kpiData for CustomerVisitTracker", kpiData);
useEffect(() => {
  if (kpiData?.hcp_table_data && Array.isArray(kpiData.hcp_table_data)) {
    setHcpData(kpiData.hcp_table_data);
  } else {
    setHcpData([]); 
  }
  setLoading(false);
}, [kpiData]);

const handleDownload = () => {
    if (!hcpData || hcpData.length === 0) {
      alert("No data available for download");
      return;
    }

    // ✅ Prepare CSV data based on selection
    let csvData = [];

if (selectedType === "visit") {

  // Step 1: Collect months
  // const allMonths = new Set<string>();
  // hcpData.forEach(hcp => {
  //   Object.keys(hcp.monthly_visitsAndDMs || {}).forEach(m => allMonths.add(m));
  // });
const sortedMonths = dynamicMonthOrder;
  csvData = hcpData.map((hcp) => {
    const [hcpCode, hcpName, speciality, category] =
      hcp.hcp_details?.split(" | ") || ["-", "-", "-", "-"];

    const row = {
        "SAP Code": hcp.user_name || "-",
     "User Name": hcp.user_full_name || "-",
       "User Role": hcp.user_role || "-",
      "HCP Code": hcpCode,
      "HCP Name": hcpName,
      Speciality: speciality,
      Category: category,
        "Target frequency": hcp.total_frequency || 0,
      "Total Visit": hcp.total_visit || 0,
      
    };

    sortedMonths.forEach((m) => {
      const mon = (hcp.monthly_visitsAndDMs?.[m] as MonthlyEntry) || { visits: 0, visitdates: [] , frequency : 0};
      row[`${m} Visit`] = mon.visits;
      row[`${m} Dates`] = mon.visitdates.join(", "); 
    });

    return row;
  });

  // Step 3: Add GRAND TOTAL ROW
  const grandTotalRow = {
    "HCP Code": "",
    "HCP Name": "",
    Speciality: "",
    Category: "Grand Total Visit",
     "Target Frequency": kpiData?.grand_total_frequency || 0,
    "Total Visit": kpiData?.grand_total_visit ?? 0,
  };

  // Fill all month columns with blanks
  sortedMonths.forEach((m) => {
    grandTotalRow[`${m} Visit`] = "";
    grandTotalRow[`${m} Dates`] = "";
  });

  // Add year in last column
  grandTotalRow["FY"] = kpiData?.year?.[0] || "";

  csvData.push(grandTotalRow);
}
else {
      csvData = hcpData.map((hcp) => {
        const [hcpCode, hcpName, speciality, category] =
          hcp.hcp_details?.split(" | ") || ["-", "-", "-", "-"];

        return {
          "SAP Code": hcp.user_name || "-",
          "User Name": hcp.user_full_name || "-",
          "User Role": hcp.user_role || "-",
          "HCP Code": hcpCode,
          "HCP Name": hcpName,
          Speciality: speciality,
          Category: category,
          DMs: hcp.dm || "0",
          Frequency : hcp.total_frequency || "0",
        };
      });
    }

    // ✅ Convert to CSV using XLSX
    const headers = Object.keys(csvData[0] || {});
    const worksheet = XLSX.utils.json_to_sheet(csvData, { header: headers });
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    // ✅ Cross-environment setup
    const isReactNativeWebView = !!window.ReactNativeWebView;
    const isInIframe = window.self !== window.top;

    const message = {
      type: "DOWNLOAD_CSV",
      csv: btoa(unescape(encodeURIComponent(csv))),
      fileName:
        selectedType === "visit"
          ? "Customer_Visits_Report.csv"
          : "Customer_DMs_Report.csv",
      mimeType: "text/csv",
    };

    if (isReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    } else if (isInIframe) {
       const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customer_Visit_Tracker");
      XLSX.writeFile(workbook, "Customer_Visit_Tracker.xlsx");
      window.parent.postMessage(JSON.stringify(message), "https://bsvdashprod.mankindpharma.in");
      setOpen(false);
    } else {
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        selectedType === "visit"
          ? "Customer_Visits_Report.csv"
          : "Customer_DMs_Report.csv"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
          setOpen(false);
    }

    setOpen(false);
  };



const fyYears = kpiData?.year?.map(String) || [];
const dynamicMonthOrder = generateFullFinancialYearMonthsFromYears(fyYears);

const isDesktop = useMediaQuery('(min-width:950px)');

 const grandTotalVisit = kpiData?.grand_total_visit ?? 0;
  const renderTableHead = () => (
   <TableHead className="Customer-visit-table-head">
      <TableRow>
        <TableCell sx={{ whiteSpace: "pre-wrap" , width: "130px" ,position :'sticky' , left :"0px" , zIndex : '100 !important'}} >HCP Details</TableCell>
        <TableCell sx={{ whiteSpace: "pre-wrap" , width: "50px" }}>DM</TableCell>
           <TableCell sx={{ whiteSpace: "pre-wrap" , width: "50px",  padding :'0px' }}>Total Frequency</TableCell>
        <TableCell sx={{ whiteSpace: "pre-wrap" , width: "50px" }}>Avg Monthly DMS</TableCell>
        <TableCell sx={{  width: "100px" , padding :'0px' }}>No. of Visits/DMs</TableCell>
        <TableCell sx={{  width: "80px" , padding :'0px' , alignItems : 'center'}} >Total</TableCell>
      {dynamicMonthOrder.map((month) => {
const formattedMonth = (() => {
  const short = month.slice(0, 3);
  const year = month.slice(3);
  return `${short.charAt(0).toUpperCase() + short.slice(1)}’${year}`;
})();

  
  return (
    <TableCell
      sx={{ whiteSpace: "pre-wrap", width: "100px" }}
      key={month}
    >
      {formattedMonth}
    </TableCell>
  );
})}

      </TableRow>
    </TableHead>
  );

  const renderTableBody = () => {
    if (loading) {
      return (
        <TableRow>
          <TableCell colSpan={dynamicMonthOrder.length + 5} align="center">Loading...</TableCell>
        </TableRow>
      );
    }

    if (!Array.isArray(hcpData) || hcpData.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={dynamicMonthOrder.length + 5} align="center" sx={{ fontStyle: "italic" }}>
            No data available.
          </TableCell>
        </TableRow>
      );
    }
return hcpData.map((hcp, index) => (
  <>
  <TableRow key={index}>
    <TableCell sx={{ whiteSpace: "pre-wrap",fontSize : '12px', border: "1px solid #e0e0e0"  ,  position: "sticky",
    left: 0,
    zIndex: 1, // slightly lower than header
    background: "#fff", padding :'0px',color : '#3B459E'  , fontWeight : "700" , textAlign : 'center'}} className="visit-cell">
      {hcp.hcp_details}
    </TableCell>

    <TableCell className="visit-cell"  sx={{ color : '#3B459E' ,fontSize : '12px', }}>{hcp.dm}</TableCell>
        <TableCell className="visit-cell"  sx={{ color : '#3B459E' ,fontSize : '12px', }}>{hcp.total_frequency}</TableCell>
    <TableCell className="visit-cell" sx={{ color : '#3B459E' ,fontSize : '12px', }}>{hcp.average_monthly_dms}</TableCell>

    {/* Two stacked labels in one cell */}
    <TableCell  className="visit-cell" sx={{padding : "0px !Important"}}>
       <Box >
<Box
  borderBottom="1px solid #ccc"
  p={ 1}
  sx={{ textAlign: 'center', whiteSpace: "nowrap !important" }}
>
  No. of Visits
</Box>

    <Box p={1} sx={{ textAlign: 'center'  }}>
      DMS
    </Box>
  </Box>
    </TableCell>

    <TableCell   className="visit-cell" sx={{padding : "0px !Important"  , alignItems : 'center'}}>
       <Box >
    <Box borderBottom="1px solid #ccc" p={1}  sx={{ textAlign: "center" }}>
  {hcp.total_visit}
    </Box>
    <Box p={1}  sx={{ textAlign: "center" }}>
   {hcp.total_dm}
    </Box>
  </Box>
    </TableCell>

    {/* Monthly breakdown cells */}
    {dynamicMonthOrder.map((month) => {
      const entry = hcp.monthly_visitsAndDMs?.[month];
      const visits = entry?.visits ?? 0;
      const dms = entry?.dms ?? 0;
      const visitdates = entry?.visitdates ?? [];
      const frequency = entry?.frequency ?? 0;
      return (

    <TableCell  className="visit-cell" sx={{padding : "0px !Important"}}>
 <Tooltip
   enterTouchDelay={0}           
  disableInteractive={false} 
  title={
    <Box sx={{ fontSize: "12px", lineHeight: 1.4 }}>
      <strong>Visit Dates:</strong>
      <Box component="ul" sx={{ pl: 2, m: 0 }}>
        {visitdates.length > 0 ? (
          visitdates.map((date, index) => (
            <li key={index}>{date}</li>
          ))
        ) : (
          <div>None</div>
        )}
      </Box>
       <strong>Frequency: {frequency}</strong>
    </Box>
  }
  arrow
  placement="top"
  PopperProps={{
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8], 
        },
      },
    ],
  }}
  componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#fff",
        color : "#000",
        boxShadow: 3,
        border: "1px solid #ccc",
        fontSize: "13px",
      },
      className: "custom-tooltip",
    },
    arrow: {
      sx: {
        color: "#fff", 
      },
    },
  }}
>
  <Box>
    <Box borderBottom="1px solid #ccc" p={1} sx={{ textAlign: "center" }}>
      {visits}
    </Box>
    <Box p={1} sx={{ textAlign: "center" }}>
      {dms}
    </Box>
    
  </Box>
</Tooltip>

    </TableCell>

      );
    })}
  </TableRow>
  </>

));

  };

  return (
    <Box>
      <Box className="header" sx={{ p: 2.5 }}>
        {/* <Box className="title-container"> */}
          <Box
  className="header"
  sx={{
    p: 2.5,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap", // helps keep layout responsive on tablets
  }}
>
  {/* Left side — title */}
  <Typography
    className="title"
    sx={{
      fontWeight: 700,
      fontSize: "18px",
      color: "#3B459E",
    }}
  >
    All Customer
  </Typography>

  {/* Right side — download button */}
  <Button
    variant="contained"
    sx={{
      backgroundColor: "#3B459E",
      color: "#fff",
      fontSize: "13px",
      textTransform: "none",
      borderRadius: "8px",
      padding: "6px 16px",
      "&:hover": { backgroundColor: "#2F3785" },
    }}
    // onClick={handleDownloadCSV}
    onClick={handleOpen}
  >
    Download CSV
  </Button>
{/* </Box> */}

        </Box>
      </Box>
      <Box className="Customer-container" alignItems="center" mb={2}>
          <TableContainer component={Paper}  sx={{
    maxHeight: 500, // Adjust height as needed
    overflow: "auto",
  }}>
          <Table size="small"    sx={{
      minWidth: dynamicMonthOrder.length * 120 + 600, 
      tableLayout: "auto",
      overflowX :"scroll" 
    }}stickyHeader>
            {renderTableHead()}
            <TableBody >{renderTableBody()}

              <TableRow sx={{ fontWeight: "bold" }}>
      <TableCell colSpan={3} sx={{ whiteSpace: "pre-wrap", padding : "8px !important" , maxWidth: "100px",fontSize : '14px', border: "1px solid #e0e0e0"  , color : '#3B459E'  , fontWeight : "700" , textAlign : 'center'}} className="visit-cell">
        Grand Total Visits:
      </TableCell>
      <TableCell sx={{ fontWeight: "700", fontSize: "14px" , }}>
        {grandTotalVisit}
      </TableCell>
      {dynamicMonthOrder.slice(1).map((month) => (
        <TableCell key={month} />
      ))}
    </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Modal open={open} onClose={handleClose}>
        <Box
          component={Paper}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            outline: "none",
          }}
        >
          <Typography variant="h6" mb={2}>
            Select Download Type
          </Typography>

          <RadioGroup
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <FormControlLabel value="visit" control={<Radio />} label="Visits" />
            <FormControlLabel
              value="dm"
              control={<Radio />}
              label="DMs (Live Shortly)"
            />
          </RadioGroup>

          <Box
            display="flex"
            justifyContent="flex-end"
            gap={2}
            mt={3}
          >
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleDownload}>
              Download
            </Button>
          </Box>
        </Box>
      </Modal>
      </Box>
    </Box>
  );
});

export default CustomerVisitTracker;


